
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../GlobalContext';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import config from '../../config'; // Path to your config file
import { GetById, Update } from '../../service/CountryService'; // Path to your CountryService file

export default function EditCountry() {
  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  // state
  const [name, setName] = useState('');
  const { id } = useParams();
  const [keyword, setKeyword] = useState('');

  const [status, setStatus] = useState('active');
  const [country, setCountry] = useState({});

  const fetchCountryById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      console.log("id",response);
      if (response.status === 200) {
        setCountry(response.country);
        setName(response.country.name);
        setStatus(response.country.status);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  const saveCountry = async (event) => {
    event.preventDefault();

    //check whether the name is filled and atleast have 3 chars
    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }


    setIsLoading(true);
    try {
      const response = await Update(id, name, status);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Country Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/setting/country/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to edit country. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add country. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchCountryById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> Country Manage | {config.appName}</title>
      </Helmet>

      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Edit Country</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/setting/country/list"> Country List </Link> / Country Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='form'>
                  <form onSubmit={saveCountry} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input className='form-control' type='text' value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                      </div>
                       <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <br></br>
                          <input type='radio' name='status' value="active" onChange={(e) => setStatus(e.target.value)} checked={status === 'active'} /> Active &nbsp;&nbsp;
                          <input type='radio' name='status' value="inactive" onChange={(e) => setStatus(e.target.value)} checked={status === 'inactive'} /> Deactive
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'> <i className="ri-reset-right-line"></i> Reset </button>

                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'> <i className="ri-check-fill"></i> Update Country </button>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}